import { useAuthenticationStore } from "@/store";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = () => {
	const accessToken = useAuthenticationStore((state) => state.accessToken);
	if (accessToken) return <Outlet />;
	return <Navigate to="/login" replace />;
};
